import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const validWidths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const validSizes = ['xs', 'sm', 'md', 'lg'];

export default class Col extends PureComponent {
    static propTypes = {
        children: PropTypes.node,
        // additional props
        className: PropTypes.string,
        id: PropTypes.string,
        // sizes
        xs: PropTypes.oneOf(validWidths),
        sm: PropTypes.oneOf(validWidths),
        md: PropTypes.oneOf(validWidths),
        lg: PropTypes.oneOf(validWidths),
        // offsets
        xsOffset: PropTypes.oneOf(validWidths),
        smOffset: PropTypes.oneOf(validWidths),
        mdOffset: PropTypes.oneOf(validWidths),
        lgOffset: PropTypes.oneOf(validWidths),
    };

    render() {
        const { children, className, id } = this.props;
        const wrapperClasses = [
            'Col',
            className ? className : ''
        ];
        validSizes.forEach(size => {
            const width = this.props[size];
            const offset = this.props[`${size}Offset`];
            if (width) {
                wrapperClasses.push(`vx_col-${size}-${width}`);
            }
            if (offset) {
                wrapperClasses.push(`vx_col-${size}-offset-${offset}`);
            }
        });

        return (
            <div id={id} className={wrapperClasses.join(' ')}>{children}</div>
        );
    }
}
